import http from '@/plugins/axios';
import { camelToSnake } from '@/helpers/object';

export default {
  getProducts({ rowsPerPage, sortBy, descending, page, search }, mode) {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy[0] ? camelToSnake(sortBy[0]) : sortBy[0],
      order_direction: descending[0] ? 'desc' : 'asc',
      search: search,
    };
    return http.get(`/products/${camelToSnake(mode)}/datatables`, { params }).then(res => res.data);
  },
  getProductsItem({ rowsPerPage, sortBy, descending, page, search }, productId) {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy[0] ? camelToSnake(sortBy[0]) : sortBy[0],
      order_direction: descending[0] ? 'desc' : 'asc',
      search: search,
      product_id: productId,
    };
    return http.get('/products/reviews/datatables', { params }).then(res => res.data);
  },
  moveReview(payload) {
    return http.post('/move-review', {
      review_id: payload.review_id,
      product_id: payload.product_id,
    });
  },
  moveReviews(payload) {
    return http.post('/move-reviews', {
      reviews: payload.reviews,
      product_id: payload.product_id,
    });
  },
  searchProducts(search) {
    const params = {
      search,
    };
    return http
      .get('/products', {
        params,
      })
      .then(res => {
        return res.data;
      });
  },
};
